
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-security/assessment",
      function () {
        return require("private-next-pages/ai-security/assessment.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-security/assessment"])
      });
    }
  